<template>
  <div @keydown="enter">
    <!-- logo图片 -->
    <div class="header">
      <img
        src="../../assets/images/logo.png"
        alt="图片加载失败"
        style="width: 120px; height: 40px; margin-top: -10px"
      />
      <span style="font-size: 30px; font-weight: bolder; color: #7472f3">
        英语作文批改系统
      </span>
    </div>
    <!-- 登录框及背景 -->
    <div class="login_bg">
      <!-- 登录框 -->
      <table></table>
      <div class="t_table">
        <div
          style="
            margin: 15px 128px 20px;
            font-size: 22px;
            font-weight: bold;
            color: #333;
          "
        >
          用户登录
        </div>
        <div>
          <span>用户名：</span>
          <input
            type="text"
            placeholder="请输入用户名"
            autofocus="autofocus"
            class="user_name"
            v-model="userName"
          />
          <span class="login_username"></span>
        </div>
        <div>
          <span>密&nbsp;码：</span>
          <input
            type="password"
            placeholder="请输入密码"
            class="user_password"
            v-model="upwd"
          />
          <span class="login_password"></span>
        </div>
        <!-- 验证码图片生成 -->
        <div class="code" @click="refreshCode">
          <s-identify :identifyCode="identifyCode"></s-identify>
        </div>
        <!-- 验证码输入框 -->
        <div>
          <span>验证码</span>
          <div class="code_cover">
            <input
              class="indet"
              type="text"
              placeholder="请输入验证码"
              v-model="num"
            />
          </div>
          <span class="num_code"></span>
        </div>
        <el-button class="btn" type="success" @click="go">
          登 &nbsp; 录
        </el-button>
      </div>
    </div>
    <!-- 页脚说明 -->
    <div class="footer">
      <div style="font-size: 13px; color: #777">
        Copyright © 2020-2021 南京听说科技有限公司 All Rights Reserved
        <a href="https://beian.miit.gov.cn">苏ICP备09002028号-6</a>
      </div>
    </div>
  </div>
</template>
<script>
import { home } from "@/api";
import jwt_decode from "jwt-decode";
export default {
  name: "SIdentifyd",
  data() {
    return {
      identifyCodes:
        "1234567890abcdefghijklmnopqrstuvwxyzABCDEFGHIJKLMNOPQRSTUVWXYZ",
      identifyCode: "",
      name_error: false,
      pwd_error: false,
      code_error: false,
      num: "",
      userName: "",
      upwd: "",
    };
  },
  created() {},
  mounted() {
    this.identifyCode = "";
    this.makeCode(this.identifyCodes, 4);
  },
  methods: {
    //回车键登录功能设置
    enter(e) {
      let that = this;
      e = window.event || e;
      if (
        (that.$route.path === "/" || that.$route.path == "/login") &&
        (e.code == "Enter" || e.code == "enter")
      ) {
        that.go(); //登录函数
      }
    },
    randomNum(min, max) {
      return Math.floor(Math.random() * (max - min) + min);
    },
    refreshCode() {
      this.identifyCode = "";
      this.makeCode(this.identifyCodes, 4);
    },
    makeCode(o, l) {
      for (let i = 0; i < l; i++) {
        this.identifyCode +=
          this.identifyCodes[this.randomNum(0, this.identifyCodes.length)];
      }
    },
    // 验证用户名是否为空
    checkUserName() {
      if ($(".user_name").val().length == 0) {
        $(".login_username").html("用户名不能为空").show();
        $(".login_username")[0].focus();
        this.name_error = true;
      } else {
        $(".login_username").html("").show();
        this.name_error = false;
      }
    },
    // 验证密码是否为空
    checkPassword() {
      if ($(".user_password").val().length == 0) {
        $(".login_password").html("密码不能为空").show();
        $(".login_password")[0].focus();
        this.pwd_error = true;
      } else {
        $(".login_password").html("").show();
        this.pwd_error = false;
      }
    },
    // 验证验证码输入是否正确
    checkCode() {
      if (this.num) {
        if (this.num.toUpperCase() === this.identifyCode.toUpperCase()) {
          $(".num_code").html("").show();
          this.code_error = false;
        } else {
          $(".num_code").html("！验证码输入错误").show();
          this.num = "";
          this.code_error = true;
          $(".indet")[0].focus();
        }
      } else {
        $(".num_code").html("！验证码不能为空").show();
        this.num = "";
        this.code_error = true;
      }
    },
    // 判断登录后加载哪个页面
    handleJump(identity,teacherGroup){
      // 只有当身份是2、4、8时才显示任务领取页面
      if ((identity.indexOf("teacher") >= 0 && (teacherGroup  === 2 || teacherGroup === 4 || teacherGroup === 8)) || identity.indexOf("auditor") >= 0) {
        this.$router.push({ path: "/tasks" });
      } else {
        this.$router.push({ path: "/myTasks" });
      }
    },
    go() {
      this.checkUserName();
      this.checkPassword();
      this.checkCode();
      if (
        this.name_error == false &&
        this.pwd_error == false &&
        this.code_error == false
      ) {
        home
          .login({ username: this.userName, password: this.upwd })
          .then((res) => {
            var token = res.headers.auth; // 拿到后端返回的token，存储在本地
            if (token) {
              localStorage.setItem("token", token);
            }
            if (res.data.retcode === 0) {
              // 检测屏幕分辨率
              var wjb = screen.width;
              let teacherGroup = jwt_decode(localStorage.getItem("token")).teacher_group;
              let identity = jwt_decode(localStorage.getItem("token")).identity;
              if((teacherGroup & 1) === 1 && (teacherGroup & 16) === 16){
                localStorage.setItem("role", 2);
              }
              if (
                wjb !== 1920 ||
                window.devicePixelRatio > 1 ||
                window.devicePixelRatio < 1
              ) {
                this.$alert(
                  "为获得最佳显示效果，建议设置屏幕分辨率为1920*1080，同时将浏览器缩放比例调整为100%！",
                  "温馨提示",
                  {
                    confirmButtonText: "确定",
                    callback: (action) => {
                      this.$message({
                        message: res.data.retmsg,
                        type: "success",
                        duration: 1000,
                        onClose: (res) => {
                          this.handleJump(identity,teacherGroup);
                        },
                      });
                    },
                  }
                );
              } else {
                this.$message({
                  message: res.data.retmsg,
                  type: "success",
                  duration: 1000,
                  onClose: (res) => {
                    this.handleJump(identity,teacherGroup);
                  },
                });
              }
            } else {
              this.$alert(res.data.retmsg, "登陆失败", {
                confirmButtonText: "确定",
                callback: (action) => {
                  this.refreshCode();
                },
              });
            }
          })
          .catch((err) => {
            this.refreshCode(); //验证码刷新
          });
      } else {
        this.refreshCode();
        return false;
      }
    },
  },
};
</script>
<style scoped>
.header {
  width: 100%;
  height: 10vh;
  line-height: 10vh;
  min-width: 380px;
  text-align: center;
}
.login_bg {
  height: 80vh;
  background: url("../../assets/images/new_banner.png") no-repeat center;
  border-bottom: 1px solid #999;
  border-width: 1.5px;
}
.t_table {
  margin: 15vh auto;
  width: 40%;
  height: 43vh;
  max-width: 470px;
  min-width: 360px;
  min-height: 370px;
  text-align: center;
  background-color: #eee;
  border: 1px solid #999;
  border-width: 1.5px;
  border-radius: 15px;
}
input {
  border: 0;
  outline: none;
  /* margin-left: 10px; */
  width: 230px;
  height: 30px;
  background: #fff;
}
.btn {
  margin-top: 10px;
  width: 315px;
  height: 35px;
  border: 0;
  font-size: 15px;
  border-radius: 5px;
}
.footer {
  height: 10vh;
  line-height: 10vh;
  text-align: center;
}
.footer ul {
  margin: 80px 0 30px 120px;
  display: flex;
}
ul li {
  list-style: none;
  margin-right: 10px;
  font-size: 13px;
  color: #777;
}
ul li:hover {
  color: #999;
  cursor: pointer;
}
.num_code,
.login_password,
.login_username {
  font-size: 12px;
  color: #f00;
  display: block;
  margin-left: 68px;
  height: 15px;
}
.code_cover {
  display: inline-block;
  width: 248px;
  height: 32px;
  border: 1px solid #81858a33;
  background: #fff;
  margin-left: 13px;
}
.user_name,
.user_password {
  width: 245px;
  height: 32px;
}
.user_password {
  margin-left: 12px;
}
.upwd_cover {
  margin-left: 2px;
}
</style>
